var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeWidth: 0.125,
    d: "M12 .813a4.437 4.437 0 0 1 4.438 4.437v2.313H19.5A1.44 1.44 0 0 1 20.938 9v10.5a1.44 1.44 0 0 1-1.438 1.438h-15A1.44 1.44 0 0 1 3.063 19.5V9A1.44 1.44 0 0 1 4.5 7.563h3.063V5.25A4.437 4.437 0 0 1 12 .813Zm-7.562 18.75h15.125V8.938H4.438zM12 13.188a1.062 1.062 0 1 1-.001 2.124A1.062 1.062 0 0 1 12 13.188Zm0-11A3.06 3.06 0 0 0 8.938 5.25v2.313h6.124V5.25A3.06 3.06 0 0 0 12 2.188Z"
  })));
};
export default SvgLock;